{
  "accountHealth": "اکاؤنٹ ہیلتھ",
  "activeCopies": "فعال کاپیاں",
  "addFavorite": "☆ Add Favorite",
  "affectedCoins": "متاثرہ کوائنز",
  "aiAlert": "AI الرٹ",
  "aiArbitrageScanner": "اے آئی آربیٹریج اسکینر",
  "aiCenter": "AI سینٹر",
  "aiConfidence": "AI اعتماد",
  "aiConfidenceMeter": "AI اعتماد میٹر",
  "aiCopyTrading": "AI کاپی ٹریڈنگ",
  "aiFinalDecision": "AI حتمی فیصلہ",
  "aiGridTrading": "اے آئی گرڈ ٹریڈنگ",
  "aiLaunchpad": "AI لانچ پیڈ",
  "aiMarketNews": "AI مارکیٹ خبریں",
  "aiMarketScanner": "اے آئی مارکیٹ اسکینر",
  "aiNews": "اے آئی نیوز",
  "aiPortfolioManager": "اے آئی پورٹ فولیو مینیجر",
  "aiProfitCalculator": "اے آئی پرافٹ کیلکولیٹر",
  "aiRankedTrader": "AI درجہ بندی شدہ تاجر",
  "aiRebalance": "AI ری بیلنس",
  "aiRecommendation": "AI تجویز",
  "aiRecommendations": "AI سفارشات",
  "aiResult": "AI نتیجہ",
  "aiRiskEngine": "AI رسک انجن",
  "aiRiskLevel": "AI رسک سطح",
  "aiRiskManager": "اے آئی رسک مینیجر",
  "aiScanResult": "AI اسکین نتیجہ",
  "aiScore": "AI اسکور",
  "aiSignal": "AI سگنل",
  "aiSmartAlerts": "اے آئی اسمارٹ الرٹس",
  "aiSubtitle": "AI سے چلنے والی ٹریڈنگ، تجزیات، آٹومیشن اور رسک مینجمنٹ۔",
  "aiSuggestions": "اے آئی تجاویز",
  "aiTitle": "مصنوعی ذہانت",
  "aiTrader": "AI تاجر",
  "aiTradingAssistant": "اے آئی ٹریڈنگ اسسٹنٹ",
  "aiTradingAssistantSubtitle": "حقیقی وقت میں AI مارکیٹ سگنلز، جذبات اور رجحان کا تجزیہ۔",
  "aiTrustScore": "AI Trust Score",
  "aiWhaleAlerts": "AI ویل الرٹس",
  "aiWhaleHeatmap": "AI ویل ہیٹ میپ",
  "aiWhaleTracker": "اے آئی وہیل ٹریکر",
  "alertType": "الرٹ کی قسم",
  "allCategories": "تمام زمرے",
  "allImpact": "تمام اثرات",
  "allImpacts": "تمام اثرات",
  "allSentiments": "تمام جذبات",
  "allSymbols": "تمام علامات",
  "apply": "Apply",
  "applySafeModeScan": "سیف موڈ اسکین لاگو کریں",
  "applying": "لاگو ہو رہا ہے...",
  "arbitrageOpportunities": "آربیٹریج مواقع",
  "assetAllocation": "اثاثہ مختصات",
  "audit": "آڈٹ",
  "backendPreviewAlerts": "الرٹس محفوظ ہونے سے پہلے یہاں دکھائی جاتی ہیں۔",
  "backendWillSaveAfterApi": "بیک اینڈ درخواست کی تصدیق کرنے کے بعد یہ محفوظ ہو جائے گا۔",
  "baseCoin": "بنیادی کوائن",
  "breaking": "بریکنگ",
  "btcDominance": "BTC ڈومیننس",
  "btcVolatilityNews": "BTC اتار چڑھاؤ کی خبریں",
  "buyDecision": "خریدیں",
  "buyExchange": "خریداری ایکسچینج",
  "buyPressure": "Buy Pressure",
  "buyPrice": "خریداری قیمت",
  "buySignal": "خریداری",
  "buyStrength": "خریداری طاقت",
  "buyVolume": "خریداری حجم",
  "buyZone": "Buy Zone",
  "calculate": "حساب کریں",
  "calculateAiProfit": "AI منافع کا حساب لگائیں",
  "calculating": "حساب لگایا جا رہا ہے...",
  "capitalGreaterThanZero": "سرمایہ صفر سے زیادہ ہونا چاہیے۔",
  "capitalProtection": "کیپیٹل پروٹیکشن",
  "category": "زمرہ",
  "clear": "صاف کریں",
  "communityScore": "کمیونٹی اسکور",
  "compoundDays": "کمپاؤنڈ دن",
  "compoundResult": "کمپاؤنڈ نتیجہ",
  "condition": "شرط",
  "confidence": "Confidence",
  "confidenceScore": "کانفیڈنس اسکور",
  "contractSafety": "Contract Safety",
  "copyTradeIdMissing": "کاپی ٹریڈ آئی ڈی موجود نہیں۔",
  "copyTrader": "کاپی ٹریڈر",
  "copyTradingStarted": "کاپی ٹریڈنگ شروع ہو گئی۔",
  "copyTradingStopped": "کاپی ٹریڈنگ روک دی گئی۔",
  "createAiAlert": "AI الرٹ بنائیں",
  "createAiOpportunity": "AI موقع بنائیں",
  "createAiWhaleAlert": "AI وہیل الرٹ بنائیں",
  "createGridStrategy": "گرڈ حکمت عملی بنائیں",
  "createLaunchpadProject": "لانچ پیڈ پروجیکٹ بنائیں",
  "createOpportunity": "موقع بنائیں",
  "createSmartAlert": "سمارٹ الرٹ بنائیں",
  "createWhaleAlert": "وہیل الرٹ بنائیں",
  "created": "بن گیا",
  "creating": "بنایا جا رہا ہے...",
  "currentPrice": "Current Price",
  "currentRiskScore": "موجودہ رسک اسکور",
  "dailyProfit": "روزانہ منافع",
  "delete": "Delete",
  "deleteCalculationConfirm": "کیا آپ واقعی اس حساب کو حذف کرنا چاہتے ہیں؟",
  "deleteMarketScanConfirm": "کیا آپ واقعی اس مارکیٹ اسکین کو حذف کرنا چاہتے ہیں؟",
  "detected": "معلوم ہوا",
  "diversification": "تنوع",
  "emailAlert": "ای میل الرٹ",
  "enableCompoundingProjection": "کمپاؤنڈنگ پروجیکشن فعال کریں",
  "enterCopyAmountFor": "کے لیے کاپی رقم درج کریں",
  "enterNewsTitle": "خبر کا عنوان درج کریں",
  "exitPrice": "خروج قیمت",
  "expectedLoss": "Expected Loss",
  "expectedProfit": "Expected Profit",
  "extremeFear": "شدید خوف",
  "extremeGreed": "شدید لالچ",
  "failedCalculateProfit": "منافع کا حساب لگانے میں ناکامی۔",
  "failedCreateArbitrageOpportunity": "آربیٹریج موقع بنانے میں ناکامی۔",
  "failedCreateGridStrategy": "گرڈ حکمت عملی بنانے میں ناکامی۔",
  "failedCreateLaunchpadProject": "لانچ پیڈ پروجیکٹ بنانے میں ناکامی۔",
  "failedCreateSmartAlert": "سمارٹ الرٹ بنانے میں ناکامی۔",
  "failedDeleteCalculation": "حساب حذف کرنے میں ناکامی۔",
  "failedDeleteMarketScan": "مارکیٹ اسکین حذف کرنے میں ناکامی۔",
  "failedLoadAiNews": "AI خبریں لوڈ کرنے میں ناکامی۔",
  "failedLoadArbitrageScanner": "آربیٹریج اسکینر لوڈ کرنے میں ناکامی۔",
  "failedLoadGridTrading": "گرڈ ٹریڈنگ لوڈ کرنے میں ناکامی۔",
  "failedLoadLaunchpad": "لانچ پیڈ لوڈ کرنے میں ناکامی۔",
  "failedLoadMarketScanner": "مارکیٹ اسکینر لوڈ کرنے میں ناکامی۔",
  "failedLoadProfitCalculator": "منافع کیلکولیٹر لوڈ کرنے میں ناکامی۔",
  "failedLoadRiskManager": "رسک منیجر لوڈ کرنے میں ناکامی۔",
  "failedLoadSmartAlerts": "سمارٹ الرٹس لوڈ کرنے میں ناکامی۔",
  "failedLoadTrustScore": "ٹرسٹ اسکور لوڈ کرنے میں ناکامی۔",
  "failedLoadWhaleHeatmap": "وہیل ہیٹ میپ لوڈ کرنے میں ناکامی۔",
  "failedLoadWhaleTracker": "وہیل ٹریکر لوڈ کرنے میں ناکامی۔",
  "failedLogins": "ناکام لاگ ان",
  "failedMarkAlertRead": "الرٹ کو پڑھا ہوا نشان زد کرنے میں ناکامی۔",
  "failedNewsAction": "یہ عمل مکمل کرنے میں ناکامی۔",
  "failedRefreshRiskProfile": "رسک پروفائل تازہ کرنے میں ناکامی۔",
  "failedRunMarketScan": "مارکیٹ اسکین چلانے میں ناکامی۔",
  "failedStartCopyTrading": "کاپی ٹریڈنگ شروع کرنے میں ناکامی۔",
  "failedStopCopyTrading": "کاپی ٹریڈنگ روکنے میں ناکامی۔",
  "failedSubmitNews": "خبر جمع کرانے میں ناکامی۔",
  "failedSyncSymbol": "علامت مطابقت پذیر کرنے میں ناکامی۔",
  "failedToLoadData": "AI ڈیٹا لوڈ کرنے میں ناکامی۔",
  "failedUpdateFavorite": "پسندیدہ اپ ڈیٹ کرنے میں ناکامی۔",
  "favorite": "★ Favorite",
  "fear": "خوف",
  "fearGreedGauge": "خوف اور لالچ گیج",
  "fearGreedIndex": "Fear & Greed Index",
  "featuredLaunch": "نمایاں لانچ",
  "generate": "تیار کریں",
  "generateAiGrid": "AI گرڈ بنائیں",
  "generating": "تیار ہو رہا ہے...",
  "greed": "لالچ",
  "gridCount": "گرڈ کی تعداد",
  "gridStrategies": "گرڈ حکمت عملیاں",
  "grids": "گرڈز",
  "hardCap": "ہارڈ کیپ",
  "heat": "حرارت",
  "high": "زیادہ",
  "highPriority": "اعلی ترجیح",
  "highRisk": "زیادہ خطرہ",
  "highRiskDetected": "زیادہ خطرہ معلوم ہوا۔",
  "highWithdrawals": "زیادہ نکاسیاں",
  "holderScore": "Holder Score",
  "impact": "اثر",
  "investment": "سرمایہ کاری",
  "kycCompleted": "KYC مکمل",
  "lastScan": "آخری اسکین",
  "lastUpdated": "آخری اپڈیٹ",
  "latestAlert": "تازہ ترین الرٹ",
  "launchpadProjects": "لانچ پیڈ پروجیکٹس",
  "liquidityScore": "Liquidity Score",
  "liveAiMarketSignal": "لائیو AI مارکیٹ سگنل",
  "liveVolume": "لائیو حجم",
  "liveWhaleAlerts": "لائیو وہیل الرٹس",
  "loading": "لوڈ ہو رہا ہے...",
  "loadingAi": "AI ڈیٹا لوڈ ہو رہا ہے...",
  "loadingAiNews": "AI خبریں لوڈ ہو رہی ہیں...",
  "loadingArbitrageScanner": "آربیٹریج اسکینر لوڈ ہو رہا ہے...",
  "loadingGridTrading": "گرڈ ٹریڈنگ لوڈ ہو رہی ہے...",
  "loadingLaunchpad": "لانچ پیڈ لوڈ ہو رہا ہے...",
  "loadingMarketScanner": "مارکیٹ اسکینر لوڈ ہو رہا ہے...",
  "loadingProfitCalculator": "منافع کیلکولیٹر لوڈ ہو رہا ہے...",
  "loadingRiskManager": "رسک منیجر لوڈ ہو رہا ہے...",
  "loadingSmartAlerts": "سمارٹ الرٹس لوڈ ہو رہی ہیں...",
  "loadingTrustScore": "ٹرسٹ اسکور لوڈ ہو رہا ہے...",
  "loadingWhaleAlerts": "وہیل الرٹس لوڈ ہو رہی ہیں...",
  "loadingWhaleHeatmap": "وہیل ہیٹ میپ لوڈ ہو رہا ہے...",
  "loadingWhaleTracker": "وہیل ٹریکر لوڈ ہو رہا ہے...",
  "lowRisk": "کم خطرہ",
  "lowRiskDetected": "کم خطرہ معلوم ہوا۔",
  "lowerPrice": "کم قیمت",
  "markRead": "پڑھا ہوا نشان زد کریں",
  "marketSentiment": "مارکیٹ سینٹیمنٹ",
  "marketType": "مارکیٹ کی قسم",
  "marketWeaknessDetected": "مارکیٹ کی کمزوری معلوم ہوئی۔",
  "maxBuy": "زیادہ سے زیادہ خرید",
  "medium": "درمیانہ",
  "mediumRisk": "Medium Risk",
  "mediumRiskDetected": "درمیانہ خطرہ معلوم ہوا۔",
  "minBuy": "کم از کم خرید",
  "minimumWhaleAmountUsd": "کم از کم وہیل رقم (USD)",
  "moderateTrend": "معتدل رجحان",
  "monthlyProfit": "ماہانہ منافع",
  "myCopyTrades": "میری کاپی ٹریڈز",
  "myMarketScanHistory": "میری مارکیٹ اسکین تاریخ",
  "myProfitHistory": "میری منافع تاریخ",
  "neutralDecision": "غیر جانبدار",
  "neutralMarketConditions": "غیر جانبدار مارکیٹ حالات۔",
  "neutralSignal": "غیر جانبدار",
  "newsFeed": "خبروں کی فیڈ",
  "noActiveCopyTrades": "کوئی فعال کاپی ٹریڈ نہیں۔",
  "noAiNewsFound": "کوئی AI خبر نہیں ملی۔",
  "noAlertsFound": "کوئی الرٹ نہیں ملا۔",
  "noCalculationYet": "ابھی تک کوئی حساب نہیں۔",
  "noDate": "کوئی تاریخ نہیں",
  "noGridStrategiesFound": "کوئی گرڈ حکمت عملی نہیں ملی۔",
  "noHeatmapDataFound": "کوئی ہیٹ میپ ڈیٹا نہیں ملا۔",
  "noLaunchpadProjectsFound": "کوئی لانچ پیڈ پروجیکٹ نہیں ملا۔",
  "noOpportunitiesFound": "کوئی موقع نہیں ملا۔",
  "noPinnedNews": "کوئی پن شدہ خبر نہیں۔",
  "noRecommendationYet": "ابھی تک کوئی سفارش نہیں۔",
  "noRiskHistoryYet": "ابھی تک کوئی رسک تاریخ نہیں۔",
  "noSavedCalculations": "کوئی محفوظ شدہ حساب نہیں۔",
  "noSavedScans": "کوئی محفوظ شدہ اسکین نہیں۔",
  "noScanYet": "ابھی تک کوئی اسکین نہیں۔",
  "noTrustScoresFound": "کوئی ٹرسٹ اسکور نہیں ملا۔",
  "noWhaleTransactionsFound": "کوئی وہیل لین دین نہیں ملا۔",
  "noWhaleWalletsDetected": "کوئی وہیل والیٹ معلوم نہیں ہوا۔",
  "notScannedYet": "ابھی تک اسکین نہیں ہوا۔",
  "p2pDisputes": "P2P تنازعات",
  "pinned": "پن شدہ",
  "pinnedNews": "پن شدہ خبریں",
  "portfolioExposure": "پورٹ فولیو ایکسپوژر",
  "portfolioRebalancedSuccessfully": "پورٹ فولیو کامیابی سے دوبارہ متوازن ہو گیا۔",
  "position": "پوزیشن",
  "priority": "ترجیح",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "projectName": "پروجیکٹ کا نام",
  "raised": "اکٹھی شدہ رقم",
  "raisedAmount": "اکٹھی شدہ رقم",
  "rebalanceFailed": "دوبارہ توازن ناکام ہو گیا۔",
  "records": "ریکارڈز",
  "refresh": "ریفریش",
  "refreshAiScan": "اے آئی اسکین ریفریش کریں",
  "risk": "خطرہ",
  "riskFactors": "خطرے کے عوامل",
  "riskHistory": "خطرے کی تاریخ",
  "riskLevel": "رسک لیول",
  "riskReward": "Risk / Reward",
  "riskRewardRatio": "رسک/ریوارڈ تناسب",
  "riskScore": "رسک اسکور",
  "roi": "آر او آئی",
  "runAiMarketScan": "AI مارکیٹ اسکین چلائیں",
  "runAiScan": "AI Scan چلائیں",
  "safe": "محفوظ",
  "scan": "اسکین کریں",
  "scanning": "اسکین ہو رہا ہے...",
  "searchAiNews": "AI خبریں تلاش کریں...",
  "searchWalletOrSymbol": "والیٹ یا علامت تلاش کریں...",
  "sellDecision": "فروخت کریں",
  "sellExchange": "فروخت ایکسچینج",
  "sellPressure": "Sell Pressure",
  "sellPrice": "فروخت قیمت",
  "sellSignal": "فروخت",
  "sellVolume": "فروخت حجم",
  "sellZone": "Sell Zone",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "signal": "سگنل",
  "signalStrength": "سگنل کی طاقت",
  "smartAlerts": "سمارٹ الرٹس",
  "softCap": "سافٹ کیپ",
  "source": "ذریعہ",
  "sourceUrl": "ذریعہ یو آر ایل",
  "spread": "اسپریڈ",
  "stop": "روکیں",
  "strongBuyDecision": "مضبوط خریداری",
  "strongBuyOpportunity": "مضبوط خریداری کا موقع۔",
  "strongTrend": "مضبوط رجحان",
  "submitAiNews": "AI خبر جمع کرائیں",
  "submitNews": "خبر جمع کرائیں",
  "submitNewsForAiAnalysis": "AI تجزیے کے لیے خبر جمع کرائیں۔",
  "suggestedCopy": "تجویز کردہ کاپی رقم",
  "suggestedLeverage": "تجویز کردہ لیوریج",
  "summary": "خلاصہ",
  "suspiciousActivity": "مشکوک سرگرمی",
  "sync": "Sync",
  "syncing": "مطابقت پذیر ہو رہا ہے...",
  "targetPrice": "ہدف قیمت",
  "telegramAlert": "ٹیلیگرام الرٹ",
  "timeframe": "ٹائم فریم",
  "title": "عنوان",
  "titleSummaryRequired": "عنوان اور خلاصہ درکار ہیں۔",
  "tokenPrice": "ٹوکن قیمت",
  "topGainers": "ٹاپ گینرز",
  "topGridStrategy": "سرکردہ گرڈ حکمت عملی",
  "topLosers": "ٹاپ لوزرز",
  "topOpportunity": "سرکردہ موقع",
  "topWhaleWallets": "سرکردہ وہیل والیٹس",
  "totalAlerts": "کل الرٹس",
  "totalCopied": "کل کاپی شدہ",
  "totalNews": "کل خبریں",
  "totalPL": "کل منافع/نقصان",
  "totalValue": "کل قیمت",
  "totalWhaleVolume": "کل وہیل حجم",
  "tradeSetup": "ٹریڈ سیٹ اپ",
  "transferVolume": "منتقلی حجم",
  "trend": "ٹرینڈ",
  "trendStrength": "رجحان کی طاقت",
  "upperPrice": "زیادہ قیمت",
  "usdValue": "USD قیمت",
  "viewDetails": "تفصیلات دیکھیں",
  "volatility": "اتار چڑھاؤ",
  "volatilityIndex": "وولاٹیلٹی انڈیکس",
  "weakTrend": "کمزور رجحان",
  "whaleAccumulation": "وہیل جمع آوری",
  "whaleActivity": "وہیل ایکٹیویٹی",
  "whaleAlertCreatedFor": "وہیل الرٹ بنایا گیا برائے",
  "whaleRisk": "Whale Risk",
  "whaleScore": "وہیل اسکور",
  "writeNewsSummary": "خبر کا خلاصہ لکھیں",
  "yearlyProfit": "سالانہ منافع"
}